// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/saved_route.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/saved_route.proto.
 */
export const file_travplaces_v1_saved_route: GenFile = /*@__PURE__*/
  fileDesc("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", [file_travplaces_v1_audit, file_travplaces_v1_authz, file_google_protobuf_timestamp]);

/**
 * SavedRoute is a device-scoped, persisted itinerary. It belongs to an
 * anonymous owner_key (browser localStorage) rather than an account. The
 * request/plan/notes payloads are raw jsonb documents rendered as JSON strings.
 *
 * @generated from message travplaces.v1.SavedRoute
 */
export type SavedRoute = Message<"travplaces.v1.SavedRoute"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string city_id = 2;
   */
  cityId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * raw jsonb — the plan request that produced it
   *
   * @generated from field: string request_json = 4;
   */
  requestJson: string;

  /**
   * raw jsonb — the computed itinerary
   *
   * @generated from field: string plan_json = 5;
   */
  planJson: string;

  /**
   * raw jsonb — free-form notes map
   *
   * @generated from field: string notes_json = 6;
   */
  notesJson: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message travplaces.v1.SavedRoute.
 * Use `create(SavedRouteSchema)` to create a new message.
 */
export const SavedRouteSchema: GenMessage<SavedRoute> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_saved_route, 0);

/**
 * SavedRouteSummary is the lightweight list projection for the owner's routes.
 *
 * @generated from message travplaces.v1.SavedRouteSummary
 */
export type SavedRouteSummary = Message<"travplaces.v1.SavedRouteSummary"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string city_id = 3;
   */
  cityId: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * Enough to describe a row in a list without fetching the whole plan.
   * Their absence is why the list used to show placeholder figures.
   *
   * @generated from field: string city_name = 5;
   */
  cityName: string;

  /**
   * @generated from field: string mode = 6;
   */
  mode: string;

  /**
   * @generated from field: int32 stop_count = 7;
   */
  stopCount: number;

  /**
   * @generated from field: int32 total_minutes = 8;
   */
  totalMinutes: number;

  /**
   * Who saved it, by username. Empty for a route saved before this was
   * recorded, which the list shows as nobody rather than as a blank name.
   *
   * @generated from field: string saved_by = 9;
   */
  savedBy: string;
};

/**
 * Describes the message travplaces.v1.SavedRouteSummary.
 * Use `create(SavedRouteSummarySchema)` to create a new message.
 */
export const SavedRouteSummarySchema: GenMessage<SavedRouteSummary> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_saved_route, 1);

/**
 *
 * What a place's coverage history is made of.
 *
 * "Covered" means a saved round or a saved operation stops there, which is
 * the only record this system keeps — nobody confirms a visit, so a coverage
 * here is a plan somebody committed to, not a fact about the ground. The
 * wording on screen says so.
 *
 * @generated from message travplaces.v1.Covering
 */
export type Covering = Message<"travplaces.v1.Covering"> & {
  /**
   * The saved route or operation this came from.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * "route" or "operation".
   *
   * @generated from field: string source = 3;
   */
  source: string;

  /**
   * Who saved it. Empty where the record predates attribution.
   *
   * @generated from field: string by = 4;
   */
  by: string;

  /**
   * What to call them, where that account has been given a name. Empty
   * otherwise, and every reader falls back to `by`. Carried beside the
   * username rather than instead of it: `by` is what identifies the person,
   * and two people may yet be called the same thing.
   *
   * @generated from field: string by_name = 13;
   */
  byName: string;

  /**
   * When it was last saved.
   *
   * @generated from field: google.protobuf.Timestamp at = 5;
   */
  at?: Timestamp | undefined;

  /**
   * Minutes the plan allowed at this place.
   *
   * @generated from field: int32 dwell_minutes = 6;
   */
  dwellMinutes: number;

  /**
   * Which day of an operation, 1-based. Zero for a single route.
   *
   * @generated from field: int32 day = 7;
   */
  day: number;

  /**
   * How many stops that route, or that day of that operation, has in all.
   * The panel needs it to tell "covers 4 of the 6 places you are asking
   * about" from "that plan has 14 stops"; without it the one number on the
   * row reads as both.
   *
   * @generated from field: int32 plan_stops = 8;
   */
  planStops: number;

  /**
   * The date it was planned for, YYYY-MM-DD, empty where none was set. Not
   * the same as `at`, which is when it was saved.
   *
   * @generated from field: string plan_date = 9;
   */
  planDate: string;

  /**
   * How far the saved stop is from the point asked about, in metres.
   *
   * Zero when the match is by place id, which is exact. A dropped pin has no
   * id to match on, so it is matched on the ground instead, and then this is
   * how near — which the screen shows, because "covered" at 38 m is a claim
   * the reader should be able to judge.
   *
   * @generated from field: double metres = 10;
   */
  metres: number;

  /**
   * What that saved plan calls the stop which matched. Worth saying for a
   * match by location, where it may be a different name entirely.
   *
   * @generated from field: string stop_name = 11;
   */
  stopName: string;

  /**
   * The hour that stop is due, HH:MM, empty where the plan sets none.
   *
   * With it, "which came first?" can be answered within a day: two plans for
   * the same date are not the same claim if one is at nine and the other at
   * four.
   *
   * @generated from field: string plan_time = 12;
   */
  planTime: string;

  /**
   * Where this stop sits in that plan's day, 1-based, and what the plan does
   * either side of it. Empty neighbours mean the day starts or ends here.
   * Together with plan_stops they answer "how is it covered", not merely
   * "is it": first call of the morning, or wedged between two others.
   *
   * @generated from field: int32 stop_index = 14;
   */
  stopIndex: number;

  /**
   * @generated from field: string prev_stop = 15;
   */
  prevStop: string;

  /**
   * @generated from field: string next_stop = 16;
   */
  nextStop: string;
};

/**
 * Describes the message travplaces.v1.Covering.
 * Use `create(CoveringSchema)` to create a new message.
 */
export const CoveringSchema: GenMessage<Covering> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_saved_route, 2);

/**
 * @generated from message travplaces.v1.PoiCoverageEntry
 */
export type PoiCoverageEntry = Message<"travplaces.v1.PoiCoverageEntry"> & {
  /**
   * Empty for an entry about a point rather than a place.
   *
   * @generated from field: string poi_id = 1;
   */
  poiId: string;

  /**
   * Every time this place has been covered, most recent first.
   *
   * @generated from field: repeated travplaces.v1.Covering coverings = 2;
   */
  coverings: Covering[];

  /**
   * Minutes spent across all of them.
   *
   * @generated from field: int32 total_minutes = 3;
   */
  totalMinutes: number;

  /**
   * What the caller asked with: the place id, or the key of the point.
   *
   * @generated from field: string key = 4;
   */
  key: string;
};

/**
 * Describes the message travplaces.v1.PoiCoverageEntry.
 * Use `create(PoiCoverageEntrySchema)` to create a new message.
 */
export const PoiCoverageEntrySchema: GenMessage<PoiCoverageEntry> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_saved_route, 3);

/**
 * A stop of the round that has no place id: a dropped pin, or a plain
 * coordinate start. Matched on the ground rather than by identity.
 *
 * @generated from message travplaces.v1.CoveragePoint
 */
export type CoveragePoint = Message<"travplaces.v1.CoveragePoint"> & {
  /**
   * The caller's own name for this point, echoed back as the entry's key.
   *
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: double lat = 2;
   */
  lat: number;

  /**
   * @generated from field: double lng = 3;
   */
  lng: number;
};

/**
 * Describes the message travplaces.v1.CoveragePoint.
 * Use `create(CoveragePointSchema)` to create a new message.
 */
export const CoveragePointSchema: GenMessage<CoveragePoint> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_saved_route, 4);

/**
 * @generated from message travplaces.v1.PoiCoverageRequest
 */
export type PoiCoverageRequest = Message<"travplaces.v1.PoiCoverageRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;

  /**
   * The places to ask about: the named stops of the round on screen.
   *
   * @generated from field: repeated string poi_ids = 2;
   */
  poiIds: string[];

  /**
   * The stops that have no place id, asked about by where they are.
   *
   * @generated from field: repeated travplaces.v1.CoveragePoint points = 3;
   */
  points: CoveragePoint[];
};

/**
 * Describes the message travplaces.v1.PoiCoverageRequest.
 * Use `create(PoiCoverageRequestSchema)` to create a new message.
 */
export const PoiCoverageRequestSchema: GenMessage<PoiCoverageRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_saved_route, 5);

/**
 * @generated from message travplaces.v1.PoiCoverageResponse
 */
export type PoiCoverageResponse = Message<"travplaces.v1.PoiCoverageResponse"> & {
  /**
   * One entry per place that has been covered. A place with no history is
   * left out rather than returned empty.
   *
   * @generated from field: repeated travplaces.v1.PoiCoverageEntry entries = 1;
   */
  entries: PoiCoverageEntry[];
};

/**
 * Describes the message travplaces.v1.PoiCoverageResponse.
 * Use `create(PoiCoverageResponseSchema)` to create a new message.
 */
export const PoiCoverageResponseSchema: GenMessage<PoiCoverageResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_saved_route, 6);

/**
 *
 * How often one place has been planned, with none of the detail.
 *
 * PoiCoverage answers "what exactly has happened here" and costs a row per
 * covering to do it. Somebody picking places off a catalogue is asking a
 * smaller question of a much larger set — has this one been worked at all,
 * and how heavily — and asking it the other way would carry tens of
 * thousands of rows to print one number beside each name.
 *
 * @generated from message travplaces.v1.PlaceTally
 */
export type PlaceTally = Message<"travplaces.v1.PlaceTally"> & {
  /**
   * @generated from field: string poi_id = 1;
   */
  poiId: string;

  /**
   * Saved plan-days stopping here. A day of an operation counts as its
   * own, and a round trip passing the same place twice counts once: the
   * same reckoning the coverage window shows, so the two never disagree.
   *
   * @generated from field: int32 plans = 2;
   */
  plans: number;

  /**
   * The latest date any of them is planned for, YYYY-MM-DD. Empty where
   * none of them sets one.
   *
   * @generated from field: string last_plan_date = 3;
   */
  lastPlanDate: string;

  /**
   * Where the place is, and what it is called.
   *
   * Carried with the figure rather than looked up beside it, because the
   * map marks every planned place in the city at once and the list it sits
   * beside has only read the first page or two. Without these, the marks
   * appeared as somebody scrolled, which is not what "already worked"
   * means.
   *
   * Taken from the catalogue where the place is still in it, and from the
   * saved stop itself where it is not: a place dropped from the catalogue
   * has still been planned, and the record should not quietly lose it.
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: double lat = 5;
   */
  lat: number;

  /**
   * @generated from field: double lng = 6;
   */
  lng: number;

  /**
   * @generated from field: string category_label = 7;
   */
  categoryLabel: string;
};

/**
 * Describes the message travplaces.v1.PlaceTally.
 * Use `create(PlaceTallySchema)` to create a new message.
 */
export const PlaceTallySchema: GenMessage<PlaceTally> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_saved_route, 7);

/**
 * @generated from message travplaces.v1.PlaceTalliesRequest
 */
export type PlaceTalliesRequest = Message<"travplaces.v1.PlaceTalliesRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;
};

/**
 * Describes the message travplaces.v1.PlaceTalliesRequest.
 * Use `create(PlaceTalliesRequestSchema)` to create a new message.
 */
export const PlaceTalliesRequestSchema: GenMessage<PlaceTalliesRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_saved_route, 8);

/**
 * @generated from message travplaces.v1.PlaceTalliesResponse
 */
export type PlaceTalliesResponse = Message<"travplaces.v1.PlaceTalliesResponse"> & {
  /**
   * Only the places some plan stops at. Everything else is new ground, and
   * saying so place by place would be most of the catalogue.
   *
   * @generated from field: repeated travplaces.v1.PlaceTally tallies = 1;
   */
  tallies: PlaceTally[];
};

/**
 * Describes the message travplaces.v1.PlaceTalliesResponse.
 * Use `create(PlaceTalliesResponseSchema)` to create a new message.
 */
export const PlaceTalliesResponseSchema: GenMessage<PlaceTalliesResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_saved_route, 9);

/**
 * @generated from message travplaces.v1.ListSavedRoutesRequest
 */
export type ListSavedRoutesRequest = Message<"travplaces.v1.ListSavedRoutesRequest"> & {
  /**
   * @generated from field: string owner_key = 1;
   */
  ownerKey: string;

  /**
   * Everybody's saved routes rather than the caller's own.
   *
   * The ordinary list is the account's work, which is what somebody opens
   * the page for. This asks the other question an operator has — what has
   * anybody planned here — and is the same ground the coverage panel
   * already reports on, so it reveals nothing the product did not already
   * show. Still a signed-in call: it is in the permission model like the
   * rest.
   *
   * @generated from field: bool everyone = 2;
   */
  everyone: boolean;
};

/**
 * Describes the message travplaces.v1.ListSavedRoutesRequest.
 * Use `create(ListSavedRoutesRequestSchema)` to create a new message.
 */
export const ListSavedRoutesRequestSchema: GenMessage<ListSavedRoutesRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_saved_route, 10);

/**
 * @generated from message travplaces.v1.ListSavedRoutesResponse
 */
export type ListSavedRoutesResponse = Message<"travplaces.v1.ListSavedRoutesResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.SavedRouteSummary routes = 1;
   */
  routes: SavedRouteSummary[];
};

/**
 * Describes the message travplaces.v1.ListSavedRoutesResponse.
 * Use `create(ListSavedRoutesResponseSchema)` to create a new message.
 */
export const ListSavedRoutesResponseSchema: GenMessage<ListSavedRoutesResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_saved_route, 11);

/**
 * @generated from message travplaces.v1.GetSavedRouteRequest
 */
export type GetSavedRouteRequest = Message<"travplaces.v1.GetSavedRouteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.GetSavedRouteRequest.
 * Use `create(GetSavedRouteRequestSchema)` to create a new message.
 */
export const GetSavedRouteRequestSchema: GenMessage<GetSavedRouteRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_saved_route, 12);

/**
 * @generated from message travplaces.v1.GetSavedRouteResponse
 */
export type GetSavedRouteResponse = Message<"travplaces.v1.GetSavedRouteResponse"> & {
  /**
   * @generated from field: travplaces.v1.SavedRoute route = 1;
   */
  route?: SavedRoute | undefined;
};

/**
 * Describes the message travplaces.v1.GetSavedRouteResponse.
 * Use `create(GetSavedRouteResponseSchema)` to create a new message.
 */
export const GetSavedRouteResponseSchema: GenMessage<GetSavedRouteResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_saved_route, 13);

/**
 * @generated from message travplaces.v1.SaveRouteRequest
 */
export type SaveRouteRequest = Message<"travplaces.v1.SaveRouteRequest"> & {
  /**
   * @generated from field: string owner_key = 1;
   */
  ownerKey: string;

  /**
   * @generated from field: string city_id = 2;
   */
  cityId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string request_json = 4;
   */
  requestJson: string;

  /**
   * @generated from field: string plan_json = 5;
   */
  planJson: string;
};

/**
 * Describes the message travplaces.v1.SaveRouteRequest.
 * Use `create(SaveRouteRequestSchema)` to create a new message.
 */
export const SaveRouteRequestSchema: GenMessage<SaveRouteRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_saved_route, 14);

/**
 * @generated from message travplaces.v1.SaveRouteResponse
 */
export type SaveRouteResponse = Message<"travplaces.v1.SaveRouteResponse"> & {
  /**
   * @generated from field: travplaces.v1.SavedRoute route = 1;
   */
  route?: SavedRoute | undefined;
};

/**
 * Describes the message travplaces.v1.SaveRouteResponse.
 * Use `create(SaveRouteResponseSchema)` to create a new message.
 */
export const SaveRouteResponseSchema: GenMessage<SaveRouteResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_saved_route, 15);

/**
 * @generated from message travplaces.v1.UpdateSavedRouteRequest
 */
export type UpdateSavedRouteRequest = Message<"travplaces.v1.UpdateSavedRouteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string plan_json = 3;
   */
  planJson: string;

  /**
   * @generated from field: string notes_json = 4;
   */
  notesJson: string;
};

/**
 * Describes the message travplaces.v1.UpdateSavedRouteRequest.
 * Use `create(UpdateSavedRouteRequestSchema)` to create a new message.
 */
export const UpdateSavedRouteRequestSchema: GenMessage<UpdateSavedRouteRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_saved_route, 16);

/**
 * @generated from message travplaces.v1.UpdateSavedRouteResponse
 */
export type UpdateSavedRouteResponse = Message<"travplaces.v1.UpdateSavedRouteResponse"> & {
  /**
   * @generated from field: travplaces.v1.SavedRoute route = 1;
   */
  route?: SavedRoute | undefined;
};

/**
 * Describes the message travplaces.v1.UpdateSavedRouteResponse.
 * Use `create(UpdateSavedRouteResponseSchema)` to create a new message.
 */
export const UpdateSavedRouteResponseSchema: GenMessage<UpdateSavedRouteResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_saved_route, 17);

/**
 * @generated from message travplaces.v1.DeleteSavedRouteRequest
 */
export type DeleteSavedRouteRequest = Message<"travplaces.v1.DeleteSavedRouteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.DeleteSavedRouteRequest.
 * Use `create(DeleteSavedRouteRequestSchema)` to create a new message.
 */
export const DeleteSavedRouteRequestSchema: GenMessage<DeleteSavedRouteRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_saved_route, 18);

/**
 * @generated from message travplaces.v1.DeleteSavedRouteResponse
 */
export type DeleteSavedRouteResponse = Message<"travplaces.v1.DeleteSavedRouteResponse"> & {
};

/**
 * Describes the message travplaces.v1.DeleteSavedRouteResponse.
 * Use `create(DeleteSavedRouteResponseSchema)` to create a new message.
 */
export const DeleteSavedRouteResponseSchema: GenMessage<DeleteSavedRouteResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_saved_route, 19);

/**
 * SavedRouteService manages device-scoped saved routes.
 *
 * @generated from service travplaces.v1.SavedRouteService
 */
export const SavedRouteService: GenService<{
  /**
   * ListSavedRoutes returns an owner's saved routes, newest first.
   *
   * @generated from rpc travplaces.v1.SavedRouteService.ListSavedRoutes
   */
  listSavedRoutes: {
    methodKind: "unary";
    input: typeof ListSavedRoutesRequestSchema;
    output: typeof ListSavedRoutesResponseSchema;
  },
  /**
   * GetSavedRoute returns one saved route by id.
   *
   * @generated from rpc travplaces.v1.SavedRouteService.GetSavedRoute
   */
  getSavedRoute: {
    methodKind: "unary";
    input: typeof GetSavedRouteRequestSchema;
    output: typeof GetSavedRouteResponseSchema;
  },
  /**
   * SaveRoute persists a new route for an owner.
   *
   * @generated from rpc travplaces.v1.SavedRouteService.SaveRoute
   */
  saveRoute: {
    methodKind: "unary";
    input: typeof SaveRouteRequestSchema;
    output: typeof SaveRouteResponseSchema;
  },
  /**
   * UpdateSavedRoute updates a route's name, plan and notes.
   *
   * @generated from rpc travplaces.v1.SavedRouteService.UpdateSavedRoute
   */
  updateSavedRoute: {
    methodKind: "unary";
    input: typeof UpdateSavedRouteRequestSchema;
    output: typeof UpdateSavedRouteResponseSchema;
  },
  /**
   * DeleteSavedRoute removes a saved route by id.
   *
   * @generated from rpc travplaces.v1.SavedRouteService.DeleteSavedRoute
   */
  deleteSavedRoute: {
    methodKind: "unary";
    input: typeof DeleteSavedRouteRequestSchema;
    output: typeof DeleteSavedRouteResponseSchema;
  },
  /**
   * PoiCoverage says which of these places have been covered before, by whom
   * and for how long. Read-only, and read from work already saved.
   *
   * @generated from rpc travplaces.v1.SavedRouteService.PoiCoverage
   */
  poiCoverage: {
    methodKind: "unary";
    input: typeof PoiCoverageRequestSchema;
    output: typeof PoiCoverageResponseSchema;
  },
  /**
   * PlaceTallies says how many saved plans stop at each place in a city:
   * one figure apiece, rather than each place's whole history.
   *
   * @generated from rpc travplaces.v1.SavedRouteService.PlaceTallies
   */
  placeTallies: {
    methodKind: "unary";
    input: typeof PlaceTalliesRequestSchema;
    output: typeof PlaceTalliesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_saved_route, 0);

